module.exports = __webpack_public_path__ + "img/reserved.487be08e.jpg";